export default __webpack_public_path__ + "static/media/ekockbp.cdd345eb.png";